import { styled } from "goober";
import { MarkdownStyles } from "./Chat/MarkdownStyles";
import { Markdown } from "./Markdown";
import { Text } from "./Text";

const Content = styled("div")`
  padding: 24px;
  max-width: 760px;
  margin: 0 auto;

  @container (min-width: 808px) {
    padding: 64px 24px;
  }
`;

export function ReadmeContent({
  children,
  internalHref,
}: {
  children: string;
  internalHref?: (href: string) => string | null;
}) {
  return (
    <Content>
      <Text variant="text-regular">
        <MarkdownStyles>
          <Markdown internalHref={internalHref}>{children}</Markdown>
        </MarkdownStyles>
      </Text>
    </Content>
  );
}
